import styled from "styled-components";

import icons from "icons";

import * as Types from "Types";

const Wrap = styled.a<Types.Default>`
   display: flex;
   width: 12px;
   height: 21px;
   align-items: center;
   position: relative;
   ${({ css }) => css}
`;
const Icon = styled.img<Types.Default>`
   max-width: 100%;
`;

function SearchIcon(props: any) {
   return (
      <Wrap {...props}>
         <Icon src={icons.back} alt="" />
      </Wrap>
   );
}

export default SearchIcon;
